module.exports = __webpack_public_path__ + "static/media/verdantix-logo-charcoal.f78f5730.svg";